var _objectAssign = require('./_objectAssign');

module.exports =
  typeof Object.assign === 'function' ? Object.assign : _objectAssign;



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_assign.js
// module id = 171
// module chunks = 1